import { FlagshipProvider } from './FlagshipProvider'

export * from '@flagship.io/js-sdk'
export * from './FlagshipHooks'
export * from './type'

export { FlagshipProvider } from './FlagshipProvider'

export default FlagshipProvider
